export const getDaysInMonth = (year: number, month: number): number => {
  if (month && year) {
    return new Date(year, month, 0).getDate();
  }

  return 31;
};
